import { render } from "./UserSheet.vue?vue&type=template&id=0dcf482b"
import script from "./UserSheet.vue?vue&type=script&lang=js"
export * from "./UserSheet.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__